import { action, computed, observable, reaction, makeObservable } from 'mobx';
import React from 'react';
import {SuccessResponse, uploadedFiles} from '../../../../../domain';
import {Disposers, HttpPromiseState, toastrHelper, toInt} from '../../../../../lib/helpers';
import {SyncedAudioModel} from '../models';

export class SyncedAudioEditStore {
  @observable
  audioUrl: string | null;
  @observable.ref
  audioFile: File | null;
  @observable.ref
  audioUpload: HttpPromiseState<SuccessResponse> | null;

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.audioUrl = null;
    this.audioFile = null;
    this.audioUpload = null;
    this.setup();
  }

  @action
  handleImageFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files === null || files.length === 0)
      this.audioFile = null;
    else
      this.audioFile = files[0];
  };

  @action
  uploadImage = () => {
    if (this.audioFile === null)
      return;
    if (this.audioUpload?.isPending === true)
      return;
    this.audioUpload = uploadedFiles.uploadAudio(this.audioFile);
  };

  @action
  clearAudio = () => {
    this.audioUrl = null;
  };

  @action
  sync = (model: SyncedAudioModel) => {
    this.audioUrl = model.audioUrl;
    this.audioFile = null;
    this.audioUpload = null;
  };

  @computed
  get valid(): boolean {
    return this.audioUrl !== null;
  }

  @computed
  get x9Contents(): string {
    if (this.audioUrl === null)
      return '';
    const model: SyncedAudioModel = {
      audioUrl: this.audioUrl
    };
    return JSON.stringify(model);
  }

  private setup() {
    this.disposers.add(reaction(
      () => this.audioUpload?.state,
      this.afterAudioUploaded));
  }

  @action
  private afterAudioUploaded = () => {
    if (this.audioUpload?.isResolved !== true)
      return;
    const results = this.audioUpload.value.Results;
    if (results.Id) {
      // single image uploaded
      const tmp = this.audioUpload.value.Results.Id;
      const id = toInt(tmp);
      if (id === null)
        return;
      this.audioUrl = uploadedFiles.audioUrl(id);
      this.audioUpload = null;
      this.audioFile = null;
    }
    if (results.Error !== null && results.Error !== undefined) {
      toastrHelper.error(results.Error);
    }
  };

  dispose = () => {
    this.disposers.dispose();
  };

}
